
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import Xiaofeng from '../components/Xiaofeng.vue'
import COVERAPP from '@/utils/COVERAPP'

@Options({
  data() {
    
  },
  components: {
    Xiaofeng,
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData'])
  },
  mounted () {
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    // homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')
  },
  methods: {
    ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
    handleEnter() {
      const _this = this;
      if (!COVERAPP.Attribute.isApp()) {
        this.SET_DIALOGDATA({
          text: '参加该活动需在封面新闻APP中进行',
          btns: [
            {
              text: '取消',
              className : 'cancel-btn'
            },
            {
              text: '确定',
              className : 'download-btn'
            }
          ]
        })
        return;
      }

      this.$common.getUser((res) => {
        console.log(res);
        const userinfo = JSON.parse(JSON.stringify(res));
        if (userinfo.token) {
          _this.SET_USERINFO(userinfo);
          _this.$router.push({ name: 'Nav' });
          return;
        }

        COVERAPP.Method.OpenLogin({
          callback: (res) => {
            if (res) {
              try {
                console.log(res);
              } catch (e) {
                console.log(e);
              }
              return;
            }

            _this.SET_DIALOGDATA({
              text: '请先登录~',
              btns: [
                {
                  text: '确定',
                  className : 'cancel-btn'
                },
              ]
            })
          }
        });

      });
    },
  },
})
export default class Home extends Vue {}
